'use client';

import { createContext, useContext } from 'react';

/**
 * The currency symbol the header balance pill should display (e.g. `USDT` /
 * `USDC` / `BTC`). The shared header lives in `apps/web` and is mounted in every
 * zone; only the trade zone knows the selected pair, so it provides this context
 * to override the default USDC balance with the pair's settle coin. Zones that
 * don't provide it (web / news / auth) read `undefined` and fall back to USDC.
 */
export const HeaderBalanceCurrencyContext = createContext<string | undefined>(undefined);

/** Header balance currency override, or `undefined` when no zone set one. */
export function useHeaderBalanceCurrency(): string | undefined {
  return useContext(HeaderBalanceCurrencyContext);
}
